// extracted by mini-css-extract-plugin
export default {"root":"H3yAo9","isMobile":"y0pd8A","isReply":"GjnzKZ","noTransitions":"i7g1OC","isPending":"QNqCJ2","isMarked":"PzmZFB","innerContainer":"cyVPf_","highlight":"l3g0t7"};